import React, { HTMLAttributeAnchorTarget } from "react";

import { Button } from "primereact/button";
import { confirmPopup } from "primereact/confirmpopup";
import { T } from "services/lang/LanguageService";
import { Link } from "react-router-dom";

type ActionButtonsProps = {
  urlOnLink?: string;
  urlTarget?: HTMLAttributeAnchorTarget;
  isPasteActive?: boolean;
  onClickCreate?: () => void;
  onClickEdit?: () => void;
  onClickDelete?: () => void;
  onClickCopy?: () => void;
  onPaste?: () => void;
};

const ActionButtons: React.FC<ActionButtonsProps> = ({
  urlOnLink,
  urlTarget,
  isPasteActive,
  onClickCreate,
  onClickEdit,
  onClickDelete,
  onClickCopy,
  onPaste
}) => {
  const confirmOnDelete = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    confirmPopup({
      target: e.currentTarget,
      message: T("alert.are-you-sure-you-want-to-proceed"),
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: onClickDelete,
    });
  };

  return (
    <div className="flex gap-1">
      {!!urlOnLink && (
        <Link to={urlOnLink} target={urlTarget}>
          <Button
            type="button"
            icon="pi pi-external-link"
            className="p-button-sm p-button-text p-1"
            style={{ width: "1.3rem" }}
            />
        </Link>
      )}
      {!!onClickCreate && (
        <Button
          type="button"
          icon="pi pi-plus"
          className="p-button-sm p-button-text p-button-success p-1"
          style={{ width: "1.3rem" }}
          onClick={onClickCreate}
          />
        )}
      {!!onClickEdit && (
        <Button
          type="button"
          icon="pi pi-pencil"
          className="p-button-sm p-button-text p-1"
          style={{ width: "1.3rem" }}
          onClick={onClickEdit}
          />
        )}
      {!!onClickCopy && (
        <Button
          type="button"
          icon="pi pi-copy"
          className="p-button-sm p-button-text p-1"
          tooltip={T("action.copy-tag-options")}
          tooltipOptions={{ position: "bottom" }}
          style={{ width: "1.3rem" }}
          onClick={onClickCopy}
          />
        )}
        {isPasteActive && !!onPaste && (
          <Button
            type="button"
            icon="pi pi-clipboard"
            className="p-button-sm p-button-text p-1"
            style={{ width: "1.3rem" }}
            tooltip={T("action.paste-tag-options")}
            tooltipOptions={{ position: "bottom" }}
            onClick={onPaste}
            />
        )}
      {!!onClickDelete && (
        <Button
          type="button"
          icon="pi pi-trash"
          className="p-button-sm p-button-text p-button-danger p-1"
          style={{ width: "1.9rem" }}
          onClick={confirmOnDelete}
        />
      )}
    </div>
  );
};

export default ActionButtons;
